import React from 'react';
import Select from '../../../../components/Form/Field/Select';
import {useDate} from '../../../../components/Date/DateProvider';
import getYear from "date-fns/getYear";
import isValid from "date-fns/isValid";
import {times} from '../../../../utils/data';

const YearSelect = props => {

    const [date, dateDispatch] = useDate();

    const [value, setValue] = React.useState('');
    const [options, setOptions] = React.useState([]);

    React.useEffect(() => {
        if(!isValid(date)) return;
        const options = years().map(year => ({value: year, name: year}));
        setValue(getYear(date));
        setOptions(options);
    }, [date]);

    const handleChange = React.useCallback(event => {
        dateDispatch({type: 'setYear', payload: event.target.value});
    }, [dateDispatch]);

    return (
        <Select
            {...props}
            options={options}
            value={value}
            onChange={handleChange}
        />
    );
};

export default YearSelect;

const years = (start = 2000, years = 100) => {
    return times(years, i => start + i);
};